import { CLASS_NAME_PREFIX } from "../__config__/constants";

export const IconClassName = `${CLASS_NAME_PREFIX}-icon`;
